export const performanceData = [
  { metric: 'Revenue Growth', value: 23, target: 20, color: '#10B981' },
  { metric: 'Customer Retention', value: 94, target: 90, color: '#3B82F6' },
  { metric: 'Cost Reduction', value: 15, target: 12, color: '#8B5CF6' },
  { metric: 'Process Efficiency', value: 87, target: 85, color: '#F59E0B' }
];

export const sampleBusinessData = [
  { month: 'Jan', revenue: 45000, costs: 32000, customers: 150, satisfaction: 4.2 },
  { month: 'Feb', revenue: 52000, costs: 35000, customers: 165, satisfaction: 4.4 },
  { month: 'Mar', revenue: 48000, costs: 33000, customers: 172, satisfaction: 4.1 },
  { month: 'Apr', revenue: 61000, costs: 38000, customers: 185, satisfaction: 4.6 },
  { month: 'May', revenue: 58000, costs: 36000, customers: 198, satisfaction: 4.5 },
  { month: 'Jun', revenue: 67000, costs: 41000, customers: 210, satisfaction: 4.7 }
];

export const skillsData = [
  { name: 'Python/R', value: 95, color: '#EF4444' },
  { name: 'SQL/NoSQL', value: 92, color: '#3B82F6' },
  { name: 'Machine Learning', value: 88, color: '#10B981' },
  { name: 'Data Viz', value: 94, color: '#8B5CF6' },
  { name: 'Cloud Platforms', value: 85, color: '#F59E0B' },
  { name: 'Business Intelligence', value: 91, color: '#EC4899' }
];
